import { creativesActions } from 'store/actions';
import { reattributionSubStr, campaignEnvironment } from 'constants';
import store from 'store';
import { checkTrackingLinks } from 'utils';

//change all trackings
export const deleteReattributionAndDispatch_allLinks = (link, field) => {
  const dispatch = store.dispatch;
  const res = link
    .split('&')
    .filter((subStr) => !subStr.includes('reattribution'))
    .join('&');
  dispatch(
    creativesActions.updateAllTrackings({
      propField: field,
      newValue: res,
    }),
  );
};

export const addReattributionAndDispatch_allLinks = (link, field) => {
  const dispatch = store.dispatch;
  const res = `${link}&${reattributionSubStr}`;
  dispatch(
    creativesActions.updateAllTrackings({
      propField: field,
      newValue: res,
    }),
  );
};

export const deleteReattributionAndDispatch_oneLink = (link, field, id) => {
  const dispatch = store.dispatch;
  const res = link
    .split('&')
    .filter((subStr) => !subStr.includes('reattribution'))
    .join('&');
  dispatch(
    creativesActions.updateOneFieldCurrentTracking({
      propField: field,
      newValue: res,
      idToUpdate: id,
    }),
  );
};

export const addReattributionAndDispatch_oneLink = (link, field, id) => {
  const dispatch = store.dispatch;
  const res = `${link}&${reattributionSubStr}`;
  dispatch(
    creativesActions.updateOneFieldCurrentTracking({
      propField: field,
      newValue: res,
      idToUpdate: id,
    }),
  );
};

export const changeLink_inAllId = (newUrl, field) => {
  const dispatch = store.dispatch;
  dispatch(
    creativesActions.updateAllTrackings({
      propField: field,
      newValue: newUrl,
    }),
  );
};

export const update_tc_numberInAllId = (tc_number) => {
  const dispatch = store.dispatch;
  dispatch(
    creativesActions.updateAllTrackings({
      propField: 'tracking_company',
      newValue: tc_number,
    }),
  );
};

export const updateTokensInAllTrackings = (arr) => {
  const dispatch = store.dispatch;
  dispatch(creativesActions.updateTokensInAllTrackings(arr));
};

export const showActionsCreative = (environment, isCustomTracking, activeCreativesList) => {
  const myState = store.getState();
  // const creativesList = myState?.creatives?.creativesList;
  const creativesTracking = myState?.creatives?.creativeAndTrackingData?.creativesTracking;

  if (!creativesTracking && environment === campaignEnvironment.new_empty) {
    return false;
  }

  return !checkTrackingLinks(creativesTracking, activeCreativesList) || isCustomTracking;
};
